import React from "react";
import { Spin, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ACCENT_DARK } from "../constants/quotationConstants";
import GalleryCard from "./GalleryCard";
import AddCustomTemplateCard from "./AddCustomTemplateCard";

export default function GalleryView({ templates, templatesLoading, onPickTemplate, onDeleteTemplate, deletingLayoutId }) {
  const navigate = useNavigate();

  return (
    <div style={{ fontFamily: "Arial, sans-serif", background: "#F4F6F9", minHeight: "100vh" }}>
      <div style={{ padding: "28px 32px", background: "#fff", borderBottom: "1px solid #E4E8EE" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              padding: 0,
            }}
          />
          <div>
            <div style={{ fontWeight: 700, fontSize: 20, color: ACCENT_DARK }}>Choose a quotation template</div>
            <div style={{ fontSize: 13, color: "#8A94A3", marginTop: 4 }}>
              Pick one of your saved templates below, or start from scratch with a custom template.
            </div>
          </div>
        </div>
      </div>

      <div style={{ padding: 32 }}>
        {templatesLoading ? (
          <Spin tip="Loading templates…">
            <div style={{ height: 120 }} />
          </Spin>
        ) : (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 28 }}>
            {templates.map((tpl) => (
              <GalleryCard
                key={tpl.key}
                tpl={tpl}
                onClick={() => onPickTemplate(tpl.key)}
                onDelete={onDeleteTemplate}
                deleting={deletingLayoutId === tpl.layoutId}
              />
            ))}
            <AddCustomTemplateCard onClick={() => onPickTemplate("blank")} />
          </div>
        )}
      </div>
    </div>
  );
}